
export function switchableParties(partyA, partyB) {
  if (!partyA || !partyB)
    return false

  return partyA.data.path == partyB.data.path
}